import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from '@app/shared/services/order.service';
import { Router } from '@angular/router';
import { JssService } from '@app/shared/services/jss.service';
import { MATERIAL_OPTIONS } from './material-option';
 
@Component({
  selector: 'app-jss-creation',
  templateUrl: './jss-creation.component.html',
  styleUrls: ['./jss-creation.component.css']
})
export class JssCreationComponent implements OnInit {
  
  orderList: any[] = [];
  jssList: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  searchText: string = '';
  selectedOrder: any;
  orderId: string;
  materialOptions = MATERIAL_OPTIONS;
  filteredOrderList: any[] = []; // Holds filtered and sorted orders
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' or 'desc'


  updateJssForm = this.formBuilder.group({
    id: [''], // Add control for ID

    clientName: [''],
      ticketno: [''],
      ddDate:[''],
      jssfolderno: [''],
      poNo: [''],
      refNo: [''],
      coilWidth: [''],
      coilod: [''],
      printType: [''],
      repeatLength: [''],
      printDirection: [''],
      std: [''],
      pouch: [''],
      totalGsm: [''],
      colorNames: [''],
      colorNumber: [''],
      jobName: [''],
      jobType: [''],
      orderKgs: [''],
      LamType: [''],
      coreType: [''],
      liquid: [''],
      inkType: [''],
      remark: [''],
      fdOption: [''],
      packageType: [''],
      barcode: [''],
      dispatch: [''],
      sRemrk: [''],
      cylinders: this.formBuilder.group({
        id: [''],
        supplier: [''],
        length: [''],
        circumference: [''],
        location: [''],
      }),
      materials: this.formBuilder.array([]), // Create FormArray for materials

  });
  
  constructor(private formBuilder: FormBuilder,
    private orderService: OrderService,
    private activatedRoute: ActivatedRoute,private router: Router,
    private jss: JssService, private cdr: ChangeDetectorRef) {
      
    }

    ngOnInit(): void {
      console.log('URL Params:', this.activatedRoute.snapshot.params);
      this.getConfirmedOrders();
    
      this.activatedRoute.params.subscribe((params) => {
        console.log('Route Params:', params);
        const orderId = params['id'];
        if (orderId) {
          this.orderId = orderId;
          this.updateJssForm.patchValue({ id: orderId }); // Update ID in the form
          this.updateOrder(this.orderId);
          this.showTable = false;
        } else {
          // console.error('OrderId is undefined or null in route parameters.');
        }
      });
      this.addMaterial(); // Ensure at least one material group is present

    }
    addMaterial() {
      const materialGroup = this.formBuilder.group({
        material: ['', [Validators.required]],
        thickness: ['', [Validators.required]], // Not disabled
        width: ['', [Validators.required]], // Not disabled
        selectedProcess: ['', [Validators.required]],
      });
      this.materials.push(materialGroup);
    }
    
    removeMaterial(index: number) {
      if (this.materials.length > 1) {
        this.materials.removeAt(index);
      } else {
        alert('At least one material must be present.');
      }
    }
    
    get materials(): FormArray {
      return this.updateJssForm.get('materials') as FormArray;
    }

    updateOrder(id: any) {
      this.orderService.getOrderById(id).subscribe(
        (res: any) => {
          console.log(res);
          this.updateJssForm.patchValue({
            clientName: res.clientName,
            ticketno: res.ticketno,
            poNo: res.poNo,
            refNo: res.refNo,
            ddDate: res.ddDate,
            coilWidth: res.coilWidth,
            coilod: res.coilod,
            pouch: res.orderPcs ? res.orderPcs : 0,
            jobName: res.jobName,
            jobType: res.jobType,
            orderKgs: res.orderKgs,
            remark: res.remark,
            fdOption: res.fdOption,
            packageType: res.packageType,
            barcode: res.barcode,
            dispatch:res.dispatch,
            sRemrk:res.sRemrk,
          });
    
          // Clear existing materials before adding new ones
          this.materials.clear();
    
          // Collect materials into an array, filtering out empty entries
          const materialsArray = [
            { material: res.sMat, thickness: res.thickness, width: res.width },
            ...(res.material1.length ? [{ material: res.material1[0].sMat2, thickness: res.material1[0].thickness2, width: res.material1[0].width2 }] : []),
            ...(res.material2.length ? [{ material: res.material2[0].sMat3, thickness: res.material2[0].thickness3, width: res.material2[0].width3 }] : [])
          ].filter(mat => mat.material && mat.thickness && mat.width); // Filter out empty materials
    
          materialsArray.forEach(mat => {
            const materialGroup = this.formBuilder.group({
              material: [mat.material, [Validators.required]],
              thickness: [mat.thickness, [Validators.required]],
              width: [mat.width, [Validators.required]],
              selectedProcess: ['', [Validators.required]], // Adjust if needed
            });
            this.materials.push(materialGroup);
          });
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
    
    
    
    
    getConfirmedOrders() {
      // Fetch JSS data first
      this.jss.getJssList().subscribe(
        (jssList: any[]) => {
          // Once JSS data is fetched, fetch confirmed orders
          this.orderService.getConfirmedOrders().subscribe(
            (confirmedOrders: any[]) => {
              // Filter confirmed orders where status is "Confirmed"
              const filteredOrders = confirmedOrders.filter(order => order.status === "Confirmed");
    
              // Check if the order IDs are present in the JSS data with specified statuses
              const validJssStatuses = new Set(["JssCreated", "MatAllocated", "MatProcessAllocated"]);
              const jssCreatedIds = new Set(
                jssList
                  .filter(jss => validJssStatuses.has(jss.status))
                  .map(jss => jss.id)
              );
    // console.log("this is confrmnot jsscrated",filteredOrders);
    // console.log("this is  jsscrated",jssList);
              // Remove orders from the list if their ID is in the JSS data with the specified statuses
              this.orderList = filteredOrders.filter(order => !jssCreatedIds.has(order._id));
    
              // Optionally reverse the order list and trigger change detection
              this.filteredOrderList = [...this.orderList].reverse();
    // console.log("this is not jsscrated",this.filteredOrderList);

              this.sortByColumn(this.sortColumn); // Apply initial sort if needed
              this.cdr.detectChanges(); // Trigger change detection
            },
            (err: any) => {
              console.log(err);
            }
          );
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
    
    
    
  
  showTable = true;
  formData: any = {};

  toggleView() {
    this.showTable = !this.showTable;
    this.formData = {};
  }

 
  saveOrder() {
    this.showTable = false;
    this.formData = {};
  }

  userData = new FormData();
 
  submitForm(): void {
    // Extract form data for submission
    const formData = this.updateJssForm.value;
  
    // Directly check if the form is valid
    if (this.updateJssForm.valid) {
      console.log(this.updateJssForm.value);
      // Call addJss API
      this.jss.addJss(formData).subscribe(
        (res: any) => {
          console.log('JSS entry created successfully:', res);
          this.updateJssForm.reset();
          this.router.navigate(['/jsslist']); // Navigate to jsslist
        },
        (err: any) => {
          console.error('Error creating JSS entry:', err);
          alert('An error occurred. Please try again.');
        }
      );
    } else {
      // Collect names of controls that are invalid
      const invalidControls = Object.keys(this.updateJssForm.controls)
        .filter(key => this.updateJssForm.get(key)?.invalid);
  
      const errorMessage = `Please fill out the following fields: ${invalidControls.join(', ')}`;
      alert(errorMessage);
    }
  }
  

deleteSelectedEntries() {
  const checkboxes = document.querySelectorAll('.rowCheckbox');
  const selectedIds = [];
  
  checkboxes.forEach((checkbox) => {
    if ((checkbox as HTMLInputElement).checked) {
      selectedIds.push((checkbox as HTMLInputElement).dataset.id); // Assuming dataset.id is used for ID
    }
  });

  if (selectedIds.length > 0) {
    this.orderService.deleteAllOrder(selectedIds).subscribe(
      (response) => {
        console.log('Entries deleted successfully:', response);
        // Optionally update your client list after deletion
        this.getConfirmedOrders(); // Example method to fetch clients again
      },
      (error) => {
        console.error('Error deleting entries:', error);
        // Handle error in UI or show error message
      }
    );
  } else {
    console.log('No entries selected for deletion');
    // Handle case where no entries are selected
  }
}

selectAllChanged(event: Event) {
  const checkboxes = document.querySelectorAll('.rowCheckbox');
  checkboxes.forEach((checkbox) => {
    (checkbox as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
  });
}
  


get paginatedOrderList(): any[] {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  return this.sortedAndFilteredOrders.slice(startIndex, endIndex);
}

get sortedAndFilteredOrders(): any[] {
  let sortedOrders = [...this.filteredOrderList];
  
  if (this.sortColumn) {
    sortedOrders.sort((a, b) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];
      if (this.sortDirection === 'asc') {
        return (valueA > valueB) ? 1 : (valueA < valueB) ? -1 : 0;
      } else {
        return (valueA < valueB) ? 1 : (valueA > valueB) ? -1 : 0;
      }
    });
  }
  
  return sortedOrders;
}

sortByColumn(column: string) {
  if (this.sortColumn === column) {
    this.sortDirection = (this.sortDirection === 'asc') ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }
  this.cdr.detectChanges(); // Trigger change detection if needed
}

onSearch(): void {
  this.currentPage = 1; // Reset to the first page when performing a new search
  this.filteredOrderList = this.orderList.filter(order => {
    const searchFields = ['clientName', 'refNo', 'jobType'];
    const lowerCaseSearch = this.searchText.toLowerCase();
    return searchFields.some(field => {
      const fieldValue = order[field];
      if (fieldValue && typeof fieldValue === 'string') {
        return fieldValue.toLowerCase().includes(lowerCaseSearch);
      }
      return false;
    });
  });
}

getNumberRange(end: number): number[] {
  return Array.from({ length: end }, (_, index) => index + 1);
}

ceil(value: number): number {
  return Math.ceil(value);
}

get totalItems(): number {
  return this.filteredOrderList.length;
}

calculateRangeStart(): number {
  return (this.currentPage - 1) * this.itemsPerPage + 1;
}

calculateRangeEnd(): number {
  return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
}

onPageChange(page: number): void {
  this.currentPage = page;
}

}




//   submitForm(): void {
//     if (this.updateJssForm.valid) {
//         console.log(this.updateJssForm.value);

//         // Extract form data from controls
//         const formData = {};
//         Object.keys(this.updateJssForm.controls).forEach((key) => {
//             formData[key] = this.updateJssForm.get(key)?.value;
//         });

//         // Call addJss API
//         this.jss.addJss(formData).subscribe(
//             (res: any) => {
//                 console.log('JSS entry created successfully:', res);
//                 this.updateJssForm.reset();
//                 this.router.navigate(['/jsslist']); // Navigate to the jsslist route
//             },
//             (err: any) => {
//                 console.error('Error creating JSS entry:', err);
//                 // Collect names of controls that are invalid
//         const invalidControls = Object.keys(this.updateJssForm.controls)
//         .filter((key) => this.updateJssForm.get(key)?.invalid);

//     // Create an error message based on invalid controls
//     const errorMessage = `Please fill out the following fields: ${invalidControls.join(', ')}`;
//     alert(errorMessage);
//             }
//         );
//     }
// }

  // submitForm(): void {
  //   if (this.updateJssForm.valid) {
  //     // Extract form data from controls
  //     const formData = {};
  //     Object.keys(this.updateJssForm.controls).forEach((key) => {
  //       formData[key] = this.updateJssForm.get(key)?.value;
  //     });
  
  //     // Call UnsavedOrder API
  //     this.jss.addJss(formData).subscribe(
  //       (res: any) => {
  //         console.log('Unsaved order response:', res);
  //         this.updateJssForm.reset();

  //       //  // Update order status
  //       //  this.updateOrderStatus(this.orderId);

  //       //  // Remove the order from the list
  //       //  this.removeOrderFromTable(this.orderId);
 

  //         this.router.navigate(['/jsslist']); // Navigate to the jsslist route

         
  //       },
  //       (err: any) => {
  //         console.error('Error saving unsaved order:', err);
  //         // Handle the error in the UI or take appropriate action
  //       }
  //     );
  //   }
  // }
//   submitForm(): void {
//     if (this.updateJssForm.valid) {
//       console.log(this.updateJssForm.value);
//         // Extract form data from controls
//         const formData = {};
//         Object.keys(this.updateJssForm.controls).forEach((key) => {
//             formData[key] = this.updateJssForm.get(key)?.value;
//         });

//         // Call addJss API
//         this.jss.addJss(formData).subscribe(
//             (res: any) => {
//                 console.log('JSS entry created successfully:', res);
//                 this.updateJssForm.reset();
//                 this.router.navigate(['/jsslist']); // Navigate to the jsslist route
//             },
//             (err: any) => {
//                 console.error('Error creating JSS entry:', err);
//                 if (err.status === 400 && err.error && err.error.message) {
//                    // Display an alert with the error message including the id
//                    const errorMessage = `JSS entry with id ${formData [key]} already exists and is in JssCreated status.`;
//                    alert(errorMessage);
//                 } else {
//                     // Handle other error scenarios
//                     console.error('Unexpected error:', err);
//                 }
//             }
//         );
//     }
// }


//   submitForm(): void {
//     if (this.updateJssForm.valid) {
//         console.log(this.updateJssForm.value);

//         // Extract form data from controls
//         const formData = {};
//         Object.keys(this.updateJssForm.controls).forEach((key) => {
//             formData[key] = this.updateJssForm.get(key)?.value;
//         });

//         // Call addJss API
//         this.jss.addJss(formData).subscribe(
//             (res: any) => {
//                 console.log('JSS entry created successfully:', res);
//                 this.updateJssForm.reset();
//                 this.router.navigate(['/jsslist']); // Navigate to the jsslist route
//             },
//             (err: any) => {
//                 console.error('Error creating JSS entry:', err);
//                 // Collect names of controls that are invalid
//         const invalidControls = Object.keys(this.updateJssForm.controls)
//         .filter((key) => this.updateJssForm.get(key)?.invalid);

//     // Create an error message based on invalid controls
//     const errorMessage = `Please fill out the following fields: ${invalidControls.join(', ')}`;
//     alert(errorMessage);
//             }
//         );
//     }
// }

  // submitForm(): void {
  //   if (this.updateJssForm.valid) {
  //     // Extract form data from controls
  //     const formData = {};
  //     Object.keys(this.updateJssForm.controls).forEach((key) => {
  //       formData[key] = this.updateJssForm.get(key)?.value;
  //     });
  
  //     // Call UnsavedOrder API
  //     this.jss.addJss(formData).subscribe(
  //       (res: any) => {
  //         console.log('Unsaved order response:', res);
  //         this.updateJssForm.reset();

  //       //  // Update order status
  //       //  this.updateOrderStatus(this.orderId);

  //       //  // Remove the order from the list
  //       //  this.removeOrderFromTable(this.orderId);
 

  //         this.router.navigate(['/jsslist']); // Navigate to the jsslist route

         
  //       },
  //       (err: any) => {
  //         console.error('Error saving unsaved order:', err);
  //         // Handle the error in the UI or take appropriate action
  //       }
  //     );
  //   }
  // }
//   submitForm(): void {
//     if (this.updateJssForm.valid) {
//       console.log(this.updateJssForm.value);
//         // Extract form data from controls
//         const formData = {};
//         Object.keys(this.updateJssForm.controls).forEach((key) => {
//             formData[key] = this.updateJssForm.get(key)?.value;
//         });

//         // Call addJss API
//         this.jss.addJss(formData).subscribe(
//             (res: any) => {
//                 console.log('JSS entry created successfully:', res);
//                 this.updateJssForm.reset();
//                 this.router.navigate(['/jsslist']); // Navigate to the jsslist route
//             },
//             (err: any) => {
//                 console.error('Error creating JSS entry:', err);
//                 if (err.status === 400 && err.error && err.error.message) {
//                    // Display an alert with the error message including the id
//                    const errorMessage = `JSS entry with id ${formData [key]} already exists and is in JssCreated status.`;
//                    alert(errorMessage);
//                 } else {
//                     // Handle other error scenarios
//                     console.error('Unexpected error:', err);
//                 }
//             }
//         );
//     }
// }
